import { render, staticRenderFns } from "./TermUse.vue?vue&type=template&id=53a61a73&"
import script from "./TermUse.vue?vue&type=script&lang=js&"
export * from "./TermUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports